var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row colorPicker",
      attrs: { id: _vm.model.componentSetting.id }
    },
    [
      _c("div", { staticClass: "col-lg-1" }),
      _c("div", { staticClass: "col-lg-10" }, [
        _c(
          "div",
          {
            staticClass: "white-background box-shadow p-4 mb-4",
            attrs: { id: "step1a" }
          },
          [
            _c("h3", { staticClass: "mb-4" }, [
              _vm._v(_vm._s(_vm.model.componentSetting.title))
            ]),
            _c("p", { staticClass: "bodytext" }, [
              _vm._v(_vm._s(_vm.model.componentSetting.description))
            ]),
            _c(
              "div",
              {
                staticClass:
                  "color-palette-calcator life facade position-relative mb-4",
                attrs: { id: _vm.colorPickerId }
              },
              [
                _c("div", { staticClass: "colorPicker-carousel" }, [
                  _c(
                    "div",
                    { staticClass: "m-0" },
                    [
                      _c(
                        "slick",
                        {
                          ref: "slick",
                          staticClass:
                            "color-selection life desktop carousel mb-3",
                          attrs: { options: _vm.slickOptions },
                          on: { afterChange: _vm.handleAfterChange }
                        },
                        _vm._l(Math.ceil(_vm.allColors.length / 9), function(
                          i
                        ) {
                          return _c("div", { staticClass: "palette-row" }, [
                            _c(
                              "div",
                              { staticClass: "palette-color" },
                              [
                                _vm._l(
                                  _vm.allColors.slice((i - 1) * 9, i * 9),
                                  function(color) {
                                    return [
                                      color.id > 0
                                        ? _c("div", {
                                            class: [
                                              "color-calculator",
                                              color.name == "0019"
                                                ? "white"
                                                : ""
                                            ],
                                            style: {
                                              "background-color":
                                                "#" + color.hex
                                            },
                                            attrs: {
                                              "data-hex": color.hex,
                                              "data-name": color.name,
                                              "data-id": color.id
                                            }
                                          })
                                        : _c("div", {
                                            staticClass:
                                              "color-calculator empty"
                                          })
                                    ]
                                  }
                                )
                              ],
                              2
                            )
                          ])
                        }),
                        0
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "color-detail-calculator calculator-style" },
                  [
                    _c(
                      "div",
                      { staticClass: "inner container-fluid box-shadow" },
                      [
                        _vm._m(0),
                        _c("div", { staticClass: "row" }, [
                          _vm._m(1),
                          _c("div", { staticClass: "col-6" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col box" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.trans("colorpicker_colorname"))
                                  )
                                ]),
                                _c("p", { staticClass: "color-name" }, [
                                  _vm._v("color_name")
                                ]),
                                _c("p", { staticClass: "color-code" }, [
                                  _vm._v(
                                    _vm._s(_vm.trans("colorpicker_hex")) + ": "
                                  ),
                                  _c("span", { staticClass: "hex" }, [
                                    _vm._v("hex_code")
                                  ])
                                ]),
                                _c("p", { staticClass: "color-code" }, [
                                  _vm._v(
                                    _vm._s(_vm.trans("colorpicker_rgb")) + ": "
                                  ),
                                  _c("span", { staticClass: "rgb" }, [
                                    _vm._v("rgb_code")
                                  ])
                                ]),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "color-pickup calculator-style button type-2 mt-2 float-right d-block",
                                    attrs: { role: "button" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.trans("colorpicker_select"))
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _c("div", {
                            domProps: { innerHTML: _vm._s(_vm.qr.outerHTML) }
                          })
                        ])
                      ]
                    )
                  ]
                ),
                _c("h4", [_vm._v(_vm._s(_vm.trans("colorpicker_search")))]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 pr-5 col-xs-12 col-md-5 col-lg-4" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "search-container color-code box-shadow visible position-relative m-0"
                        },
                        [
                          _c("input", {
                            staticClass: "toLeft colorSerachTyphead",
                            attrs: {
                              id: "footingColorSearch",
                              type: "text",
                              name: "colorCode",
                              placeholder: _vm.trans("colorpicker_search")
                            }
                          }),
                          _vm._m(2)
                        ]
                      )
                    ]
                  )
                ])
              ]
            )
          ]
        )
      ]),
      _c("div", { staticClass: "col-lg-1" })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "close-button" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("clear")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6" }, [
      _c("div", { staticClass: "color-image" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "search-button toLeft",
        staticStyle: {
          position: "absolue",
          top: "0",
          right: "0",
          "z-index": "1000"
        },
        attrs: { id: "footingColorSearchButton" }
      },
      [_c("span", { staticClass: "mdi mdi-magnify" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }